export const FETCH_SCAN_TYPES = "FETCH_SCAN_TYPES";
export const FETCH_SCAN_TYPES_CALENDAR = "FETCH_SCAN_TYPES_CALENDAR";
export const FETCH_SCAN_TYPES_START = "FETCH_SCAN_TYPES_START";
export const FETCH_SCAN_TYPES_SUCCESS = "FETCH_SCAN_TYPES_SUCCESS";
export const FETCH_SCAN_TYPES_ERROR = "FETCH_SCAN_TYPES_ERROR";

export const ADD_UPDATE_SCAN_TYPE = "ADD_UPDATE_SCAN_TYPE";
export const ADD_UPDATE_SCAN_TYPE_START = "ADD_UPDATE_SCAN_TYPE_START";
export const ADD_UPDATE_SCAN_TYPE_SUCCESS = "ADD_UPDATE_SCAN_TYPE_SUCCESS";
export const ADD_UPDATE_SCAN_TYPE_ERROR = "ADD_UPDATE_SCAN_TYPE_ERROR";
export const SET_SCAN_TYPES_PAGINATION = "SET_SCAN_TYPES_PAGINATION";

export const fetchScanTypes = (payload = null) => {
    const data = {
        type: FETCH_SCAN_TYPES,
    }
    
    if(payload) data.payload = payload;

    return data;
};

export const fetchScanTypesCalendar = () => ({
    type: FETCH_SCAN_TYPES_CALENDAR,
});

export const addUpdateScanType = (scanType, closeModal) => {
    return {
        type: ADD_UPDATE_SCAN_TYPE,
        payload: {
            scanType,
            closeModal
        }
    };
};
